import script from "./special-date.vue?vue&type=script&lang=ts&setup=true"
export * from "./special-date.vue?vue&type=script&lang=ts&setup=true"

import "./special-date.vue?vue&type=style&index=0&id=b1c144bc&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1c144bc"]])

export default __exports__